/**
 * Reduce browser-injected print headers/footers (date, title, URL).
 * Chrome draws those in the @page margin; margin: 0 plus an empty title usually removes them.
 */
let savedDocumentTitle = null;

export function prepareBrowserPrint() {
  savedDocumentTitle = document.title;
  document.title = '\u00a0';
}

export function restoreBrowserPrint() {
  if (savedDocumentTitle != null) {
    document.title = savedDocumentTitle;
    savedDocumentTitle = null;
  }
}

/** Apply print layout to a sheet root only (keeps app chrome visible on screen). */
export function enablePrintCapture(rootEl) {
  rootEl?.classList.add('prep-sheet-print-capture');
}

export function disablePrintCapture(rootEl) {
  rootEl?.classList.remove('prep-sheet-print-capture');
}
